import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type React from 'react'
import { type ReactElement, useEffect, useRef, useState } from 'react'
import {
  editorButtonToggle,
  editorButtonToggleActive,
  editorDropdownPanel,
  editorSplitButton,
  editorSplitButtonChevron
} from './EditorInput.css'

type SplitButtonDropdownProps = {
  icon: ReactElement
  onMainClick: () => void
  isActive?: boolean
  children: React.ReactNode
}

export const SplitButtonDropdown = ({
  icon,
  onMainClick,
  isActive,
  children
}: SplitButtonDropdownProps) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    if (open) document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [open])

  return (
    <div ref={ref} className={editorSplitButton}>
      <button
        type="button"
        className={clsx(
          editorButtonToggle,
          isActive && editorButtonToggleActive
        )}
        style={{ paddingRight: 2 }}
        onClick={onMainClick}
      >
        {icon}
      </button>
      <button
        type="button"
        className={editorSplitButtonChevron}
        onClick={() => setOpen((v) => !v)}
      >
        <FontAwesomeIcon icon={faChevronDown} />
      </button>
      {open && (
        <div className={editorDropdownPanel} onClick={() => setOpen(false)}>
          {children}
        </div>
      )}
    </div>
  )
}
